'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgFlashOn(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M4.745 2.643v5.792c0 .354.315.643.7.643h1.4v4.6c0 .329.469.445.651.162l3.633-5.727c.273-.431-.063-.965-.602-.965H8.945l1.743-4.28c.175-.418-.161-.868-.651-.868H5.445c-.385 0-.7.29-.7.643z", fill: "currentColor" }))));
}

module.exports = SvgFlashOn;
//# sourceMappingURL=FlashOn.js.map
